import Route from 'cio/routes/base';
import { hash } from 'rsvp';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import SegmentModel from 'cio/models/segment';
import DS from 'ember-data';
import { IdentifierKey } from 'cio/utils/identifiers';

export default class NewRoute extends Route {
  @service environment!: EnvironmentService;
  @service store!: DS.Store;

  crumb() {
    let { segment } = this.modelFor(this.routeName) as { segment: SegmentModel };

    return {
      name: 'Add by CSV',
      path: 'imports.csv.new',
      model: segment,
    };
  }

  model() {
    let segment = this.modelFor('segments.segment');

    return hash({
      segment,
      import: this.store.createRecord('import', {
        type: 'segment',
        segment,
        validateRules: {
          onlyExisting: true,
          excludeExisting: false,
          matchEmail: false,
          identifier: IdentifierKey.Id,
          noId: this.environment.current.isEmailIdentified,
        },
      }),
    });
  }
}
